var Pastebin = require('pastebin');


var PastebinView = Backbone.View.extend({
    tagName: 'div',
    className: 'paste',
    model: Pastebin,
    events: {
        'buttonClick .deleteButton': 'removePrompt',
        'buttonClick .editButton': 'toggleEdit',
        'buttonClick .linesButton': 'toggleLines',
        'buttonClick .editForm .cancel': 'toggleEdit',
        'submit .editForm': 'submitEditForm'
    },
    lines: function (lineLen) {
        lineLen = lineLen || this.model.get('lines');
        var lines = '';
        if (lineLen) {
            lines = lineLen + ' line';
            if (lineLen != 1) {
                lines += 's';
            }
        }
        return lines;
    },
    toggleLines: function (e) {
        e.preventDefault();
        this.doToggleLines();
    },
    doToggleLines: function () {
        this.$el.toggleClass('nolinenums');
        this.ace.renderer.setShowGutter(!this.ace.renderer.getShowGutter());
    },
    updateSyntaxSelect: function (name) {
        var value = this.getAceMode(name).name;
        this.select.val(value).change();
    },
    chooseExtension: function (name, ext) {
        // Choose an extension from modelist, can be multiple e.g. sh = sh|bash|^.bashrc
        var modelist = window.ace.require("ace/ext/modelist");
        var mode = modelist.modesByName[ext];
        var match = name.match(mode.extRe);
        if (match) {
            return match[0].split('.').pop();
        } else {
            return mode.extensions.split('|')[0].replace(/^\^\.?/, ''); 
        }
    },
    getAceTheme: function () {
        var theme = (
            PastebinView.themeMap[this.model.getTheme()] ||
            PastebinView.themeMap['dawn']
        );
        return 'ace/theme/' + theme;
    },
    getAceMode: function (name) {
        var modelist = window.ace.require("ace/ext/modelist");
        var mode;
        if (name) {
            mode = modelist.getModeForPath(name);
        } else {
            mode = modelist.getModeForPath(this.model.get('extension'));
            var dotMode = modelist.getModeForPath('.' + this.model.get('extension'));
            if (mode.name != dotMode.name) {
                mode = (mode.name === 'text') ? dotMode : mode;
            }
        }
        mode.path = mode.mode;
        return mode;
    },
    aceModePretty: function (mode) {
        if (mode.name == 'text') {
            return 'Plain Text';
        }
        return mode.caption;
    },
    renderSyntaxSelect: function (nameInput) {
        this.select = $('<select name="aceMode">');
        var langs = [];
        var modelist = window.ace.require("ace/ext/modelist");
        _.each(modelist.modesByName, function (mode, name) {
            if (name !== 'text') {
                langs.push(mode);
            }
        });
        langs.sort(function (a, b) {
            return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
        });
        langs.unshift(modelist.modesByName.text);
        _.each(langs, _.bind(function (mode) {
            this.select.append($('<option>').attr('value', mode.name).text(this.aceModePretty(mode)));
        }, this));
        this.updateSyntaxSelect();

        this.select.on('change', _.bind(function () {
            var mode = modelist.modesByName[this.select.val()];
            mode.path = mode.mode;
            this.updateMode(mode);
        }, this));

        if (nameInput) {
            nameInput.on('input keyup update', _.debounce(_.bind(function () {
                this.updateSyntaxSelect(nameInput.val());
            }, this), 10));
        }
        return this;
    },
    toggleEdit: function (e) {
        if (e) {
            e.preventDefault();
        }
        this.hideEditError();
        this.renderName();
        this.renderBody();
        this.updateSyntaxSelect();
        this.$el.toggleClass('edit');
        var readOnlyCurrent = this.ace.getOption('readOnly');
        this.ace.setOptions({
            readOnly: !readOnlyCurrent,
            // workaround for disappearing editor when clearing all and
            // beginning to type an html tag/or other foldable line on the first line
            minLines: readOnlyCurrent ? 7 : 1
        });
        this.ace.resize();
        this.$('.nameInput').select().focus();
        this.trigger('toggleEdit');
    },
    save: function (name, callback) {
        var aceMode = this.select ? this.select.val() : this.getAceMode().name;
        var extension = this.chooseExtension(name, aceMode);
        var body = this.ace ? this.editorContents() : this.model.getBody();
        return this.model.save({
            name: name,
            extension: extension,
            contents: body
        }, callback);
    },
    submitEditForm: function (e) {
        e.preventDefault();
        this.editForm.addSpin();
        var data = this.editForm.serializeForm();
        this.hideEditError();
        var extension = this.chooseExtension(data.name, data.aceMode);
        var body = this.editorContents();
        this.model.edit({
            name: data.name,
            extension: extension,
            body: body
        }, _.bind(function (response) {
            this.editForm.removeSpin();
            if (response.success) {
                this.toggleEdit();
            } else {
                var message = "";
                switch (response.message) {
                case 'auth':
                    message = 'You don’t have permission to edit this pastebin';
                    break;
                case 'missing_extension':
                    message = 'Missing file extension';
                    break;
                case 'not_found':
                    message = 'Unknown pastebin';
                    break;
                case 'paste_too_large':
                    message = "Sorry, you can’t paste more than 50 KB of text.";
                    break;
                case 'paste_invalid':
                    message = "Sorry, you need to paste valid UTF8.";
                    break;
                case 'paste_empty':
                    message = "No empty pastes allowed";
                    break;
                case 'server_error':
                    message = 'There was a problem editing this pastebin';
                    break;
                default:
                    message = 'There was a problem editing this pastebin: ' + response.message;
                    break;
                }
                this.showEditError(message);
            }
        }, this));
    },
    hideEditError: function () {
        this.editError.hide();
    },
    showEditError: function (text) {
        this.editError.text(text).fadeIn('fast');
    },
    removePrompt: function (e) {
        e.preventDefault();
        var actions = this.$('span.actions');
        var confirm = this.$('span.confirm');
        confirm.one('buttonClick', 'button', _.bind(function (e) {
            confirm.hide();
            if ($(e.target).is('button.delete')) {
                this.model.remove(function (response) {
                    if (!response.success && response.message != 'not_found') {
                        actions.removeClass('show');
                    }
                });
            } else {
                actions.removeClass('show');
            }
            return false;
        }, this));
        confirm.show();
        actions.addClass('show');
    },
    clearTimeago: function () {
        this.$('.details .date').timeago('dispose');
    },
    collapse: function (animate) {
        this.clearTimeago();
        if (animate) {
            $(this.el).slideUp(100).fadeOut();
        } else {
            $(this.el).hide();
        }
    },
    renderEditForm: function () {
        var nameInput = $('<input class="input nameInput" name="name">');
        this.renderSyntaxSelect(nameInput);
        var editSubmit = $('<button type="submit" class="action">').append($('<span>').text('Save'));
        var editCancel = $('<button type="button" class="cancel">').append($('<span>').text('Cancel'));
        return $('<form action="" method="post" class="editForm">')
            .append($('<p class="form">')
                .append(nameInput)
                .append(this.select)
                .append(editSubmit)
                .append(editCancel)
            );
    },
    syntax: function () {
        return this.aceModePretty(this.getAceMode());
    },
    renderName: function () {
        this.$('.nameInput').val(this.model.get('name'));
        this.$('.name').text(this.model.get('name'));
    },
    renderLines: function () {
        this.$('span.lines').text(this.lines());
    },
    renderSyntax: function () {
        this.$('.syntax').text(this.syntax());
    },
    renderMobileHeader: function (options) {
        var header = $('<div class="mobileHeader">');
        
        header.append($('<p class="name">'));
        
        var date = this.model.getDate();
        var formatString = 'dd MMMM yyyy HH:mm';
        header.append($('<p class="date">').text(date.toString(formatString)));
        
        header.append($('<p class="info">')
            .append($('<span class="syntax">'))
            .append(' • ')
            .append($('<span class="lines">'))
        );
        
        return header;
    },
    renderHeader: function (options) {
        var header = $('<h1 class="header">');

        var details = $('<span class="details">')
            .append($('<span class="name">'))
            .append(' ')
            .append($('<span class="info">')
                .append($('<span class="syntax">'))
                .append(' • ')
                .append($('<span class="lines">'))
                .append(' ')
            );
        if (options.date) {
            var date = this.model.getDate();
            var dateContainer;
            if (options.linkDate) {
                dateContainer = $('<a target="_blank" rel="noreferrer">').attr('href', this.model.getUrl());
            } else {
                dateContainer = $('<span>');
            }
            dateContainer
                .addClass('date')
                .attr('title', date.toISOString())
                .text(date.formatFullDate())
                .timeago();
            details
                .append(dateContainer)
                .append(' ');
        }
        var modes = $('<span class="modes">');
        if (this.model.get('external_url')) {
            var externalUrl;
            try {
                externalUrl = new window.URL(this.model.get('external_url'));
            } catch (exc) {
                // pass
            }
            if (externalUrl) {
                var externalLink = $('<a target="_blank" rel="noreferrer">').attr({
                    href: this.model.getUrl()
                }).text(this.model.get('service_url') || externalUrl.host);
                if (
                    this.model.get('service_name') == 'Slack' ||
                    /\.slack\.com$/.test(this.model.get('service_url')) ||
                    /\.slack\.com$/.test(externalUrl.host)
                ) {
                    externalLink.prepend('<i class="fa fa-slack">');
                }
                modes.append(externalLink);
                modes.append(' | ');
            }
        }

        var rawUrl = this.model.getRawUrl();
        if (rawUrl) {
            modes.append($('<a target="_blank" rel="noreferrer">').attr({
                href: rawUrl
            }).text('raw'));
            modes.append(' | ');
        }

        modes.append($('<button class="link linesButton">').text('line numbers'));
        modes.append(' ');
        details.append(modes);

        header.append(details);

        var actions = $('<span class="actions">');
        if (this.model.isOwn()) {
            this.editForm = this.renderEditForm();
            header.append(this.editForm);

            var deleteConfirm = $('<span class="confirm">')
                .append($('<span class="explanation">').text('Are you sure?'))
                .append($('<button type="button" class="delete">').append($('<span>').text('Yup, trash it')))
                .append($('<button type="button" class="cancel">').append($('<span>').text('Cancel')));
            header.append(deleteConfirm);

            actions.append($('<button class="link editButton">').text('edit'));
            actions.append(' • ');
            actions.append($('<button class="link deleteButton">').text('delete'));
            if (options.withClose) {
                actions.append(' • ');
            }
        }
        if (options.withClose) {
            actions.append($('<button class="link closeButton">').text('close'));
        }
        header.append(actions);

        if (this.model.isOwn()) {
            this.editError = $('<p class="userError editError">');
            header.append(this.editError);
        }

        return header;
    },
    focusEditor: function () {
        this.ace.focus();
    },
    editorContents: function () {
        return this.ace.getValue();
    },
    rendered: function () {
        this.model.bind('loaded', this.loaded, this);
        this.model.bind('fetchError', this.fetchError, this);
        this.model.bind('removed', this.removed, this);
        this.model.bind('change:name', this.renderName, this);
        this.model.bind('change:lines', this.renderLines, this);
        this.model.bind('change:extension', this.renderExtension, this);
        this.model.bind('change:body', this.renderBody, this);
        return this;
    },
    render: function (options) {
        options = options || {};
        if (options.header) {
            this.$el.append(this.renderHeader(options));
            if (options.standalone) {
                this.$el.append(this.renderMobileHeader(options));
            }
            this.renderLines();
        }

        this.renderName();
        this.renderSyntax();

        var editor = $('<div class="editor">').text(this.model.getBody());
        this.$el.append(editor);
        if (this.model.get('truncated')) {
            var moreLines = this.model.get('lines') - this.model.get('preview_lines');
            var fullLink = $('<a class="truncated">')
                .attr({
                    href: this.model.getUrl(),
                    target: '_blank',
                    rel: 'noreferrer'
                })
                .text('truncated… see full snippet');
            this.$el.append(fullLink);
        }
        this.ace = window.ace.edit(editor[0]);
        this.ace.commands.removeCommand('find');
        this.ace.commands.removeCommand('findnext');
        this.ace.commands.removeCommand('findprevious');
        this.ace.commands.removeCommand('gotoline');
        var aceOpts = {
            minLines: options.editable ? 8 : 1,
            // setting this any higher than 12 while inline breaks scrolling to bottom
            maxLines: options.standalone ? Infinity : 12, 
            readOnly: !options.editable,
            highlightActiveLine: false,
            highlightGutterLine: false,
            highlightSelectedWord: false,
            showPrintMargin: false,
            displayIndentGuides: true,
            theme: this.getAceTheme(),
            useSoftTabs: true,
            wrap: true,
            mode: "ace/mode/text",
            useWorker: false,
            cursorStyle: "slim",
            indentedSoftWrap: false
        };
        this.listenTo(this.model.session, 'prefChange:theme', function () {
            this.ace.setTheme(this.getAceTheme());
        }),
        this.ace.setOptions(aceOpts);
        this.updateMode();
        this.ace.renderer.on("afterRender", _.bind(function () {
            this.trigger('rendered');
        }, this));
        this.ace.renderer.on('resize', _.bind(function () {
            this.trigger('editorResize');
        }, this));
        this.ace.on('focus', _.bind(function (e, editor) {
            if (!this.ace.getOption('readOnly')) {
                this.ace.setOptions({
                    highlightActiveLine: true,
                    highlightGutterLine: true,
                    highlightSelectedWord: true
                });
            }
        }, this));
        this.ace.on('blur', _.bind(function (e, editor) {
            if (!this.ace.getOption('readOnly')) {
                this.ace.setOptions({
                    highlightActiveLine: false,
                    highlightGutterLine: false,
                    highlightSelectedWord: false
                });
                this.ace.clearSelection();
            }
        }, this));

        this.rendered();

        return this;
    },
    loaded: function () {
        $(this.el).removeClass('loading').addClass('loaded');
    },
    renderExtension: function () {
        this.updateMode();
        this.renderSyntax();
        this.updateSyntaxSelect();
    },
    updateMode: function (mode) {
        mode = mode || this.getAceMode();
        this.ace.getSession().setMode(mode);
    },
    renderBody: function () {
        var aceSession = this.ace.getSession();
        var scrollTop = aceSession.getScrollTop();
        this.ace.setValue(this.model.getBody());
        this.ace.clearSelection();
        aceSession.setScrollTop(scrollTop);
    },
    fetchError: function (errorStatus, errorText) {
        var error = 'Error fetching paste';
        this.$('pre.body').text(error);
        $(this.el).removeClass('loading').addClass('error');
    },
    removed: function () {
        // If it's in the backlog, revert to the link
        this.collapse();
        // Clear the body in case it's not in a backlog
        this.$('pre.body').text('Pastebin deleted');
        $(this.el).removeClass('loading').addClass('error');
    }
}, {
    TRUNCATE_LENGTH: 500,
    MESSAGE_LENGTH_TRIGGER: 1080, // 3 lines of text
    themeMap: {
        dawn: 'crimson_editor',
        dusk: 'cobalt',
        tropic: 'solarized_dark',
        emerald: 'mono_industrial',
        sand: 'twilight',
        rust: 'mono_industrial',
        orchid: 'vibrant_ink',
        ash: 'twilight',
        midnight: 'twilight'
    },
    fromPaste: function (paste, session, el) {
        return new PastebinView({
            model: new Pastebin(paste, {
                session: session
            }),
            el: el
        });
    },
    fromBody: function (body, session) {
        return PastebinView.fromPaste({
            body: body
        }, session);
    },
    fromEl: function (el, session) {
        return PastebinView.fromPaste({
            id: $(el).data('id'),
            url: $(el).data('url')
        }, session, el);
    }
});

module.exports = PastebinView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/model/pastebinview.js
// module id = 0bCg
// module chunks = 1